var React = require('react');

function Rss (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"RSS logo"),React.createElement("description",{"key":1},"Find SendGrid on RSS"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"fill":"#546B81"},[React.createElement("path",{"d":"M1.626 12a1.625 1.625 0 1 1-.002-3.25A1.625 1.625 0 0 1 1.626 12z","key":0}),React.createElement("path",{"d":"M5.511 12A5.571 5.571 0 0 0 0 6.496V4.09c4.36.031 7.888 3.555 7.92 7.91H5.511z","key":1}),React.createElement("path",{"d":"M9.592 12C9.576 6.703 5.29 2.43 0 2.406V0c6.622.023 11.985 5.384 12 12H9.592z","key":2})]))]);
}

Rss.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12"};

module.exports = Rss;

Rss.default = Rss;
